import { orderBy } from 'lodash';

import { GameItemType } from '@/pages/game/components/gameitem';
import { getGamesUrl } from '@/utils/img';

import Storage from './Storage';

export const getValidGame = (): GameItemType[] => {
  const localStorageGames = Storage.get('GAME_CONFIG');
  if (!localStorageGames?.length) return [];

  const games: GameItemType[] = [];
  localStorageGames?.forEach(item => {
    const { room_list, pack, gamename, order, available, ...props } = item;
    if (available) {
      games.push({
        order,
        room_list,
        available,
        gamename,
        pack,
        ...props,
        img: getGamesUrl(pack)
      });
    }
  });
  return orderBy(games, 'order', 'asc');
};
